// Utility to determine the correct rate for a product order
export function setRate(
  { AACost, USDRetail, KRWRetail },
  currency,
  company,
  billingCountry
) {
  console.log('[setRate] 함수 호출:', {
    AACost,
    USDRetail,
    KRWRetail,
    currency,
    company,
    billingCountry,
  });

  let result;

  if (company && company.trim() === 'Aurender America Inc.') {
    // AA로 로그인한 경우
    if (
      billingCountry &&
      billingCountry.trim().includes('United States') &&
      AACost
    ) {
      // Billing Country가 United States인 경우
      result = AACost;
      return result;
    } else {
      // Billing Country가 United States가 아닌 경우
      result = USDRetail;
      return result;
    }
  }
  if (currency && currency.trim() === 'USD') {
    result = USDRetail;
    return result;
  } else if (currency && currency.trim() === 'KRW') {
    result = KRWRetail;
    return result;
  }
  result = USDRetail;
  return result;
}
